import { Deserializable } from './deserializable.model';

export class Social implements Deserializable {
   public facebook: string;
   public twitter: string;
   public instagram: string;
   public telegram: string;
   public whatsapp: string;
   public email: string;
   public website: string;

   deserialize(input: any): this {
      Object.assign(this, input);
      return this;
   }
}
